export enum OrderTypes {
  IPEN = 'IPEN',
  HybridEClose = 'Hybrid eClose',
  RON = 'RON',
}
